import FileLoader from './fileLoader';

let _uidCounter = 0;

function generateUID() {
  const timestamp = Date.now();
  const random = Math.floor(Math.random() * 1e9);
  return `2.25.${timestamp}.${random}.${++_uidCounter}`;
}

const TXTFileLoader = new (class extends FileLoader {
  fileType = 'text/plain';

  loadFile(file, imageId) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = () => reject(reader.error);
      reader.readAsArrayBuffer(file);
    });
  }

  getDataset(arrayBuffer, imageId) {
    const dataset = {
      SOPClassUID: '2.25.4321.1',
      Modality: 'DOC',
      SeriesDescription: imageId || 'Text Document',
      StudyInstanceUID: generateUID(),
      SeriesInstanceUID: generateUID(),
      SOPInstanceUID: generateUID(),
      EncapsulatedDocument: [arrayBuffer],
      MIMETypeOfEncapsulatedDocument: 'text/plain',
      url: imageId,
    };
    return dataset;
  }
})();

export default TXTFileLoader;
